import { render, staticRenderFns } from "./RestaurantServicesDialog.vue?vue&type=template&id=d7922488"
import script from "./RestaurantServicesDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantServicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports